import { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { PatternFormat } from "react-number-format";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import LoadingPop from "components/popup/LoadingPop";
import { toastErrorSyle } from "hooks/utils/util";
import { usePostConsoleDriver, usePutConsoleDriver } from "hooks/console/useConsoleDriver";

export type DriverFormState = {
    driver_no: number | null;
    name: string;
    phone: string;
    car_no: string;
};

export default function DriverForm({
    form,
    setForm,
    update,
    setEditMode,
}: {
    form: DriverFormState;
    setForm: React.Dispatch<React.SetStateAction<DriverFormState>>;
    update?: boolean;
    setEditMode?: React.Dispatch<React.SetStateAction<boolean>>;
}) {
    const navigate = useNavigate();
    const { mutate: createDriver, isPending } = usePostConsoleDriver();
    const { mutate: updateDriver, isPending: isPendingUpdate } = usePutConsoleDriver();

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();

        if (!form.name.trim()) return toast.error("기사명을 입력해주세요.", toastErrorSyle);
        if (!form.phone.trim()) return toast.error("전화번호를 입력해주세요.", toastErrorSyle);
        if (!form.car_no.trim()) return toast.error("차량번호를 입력해주세요.", toastErrorSyle);

        const body = { name: form.name, phone: form.phone, car_no: form.car_no };

        if (update && form.driver_no) {
            updateDriver(
                { ...body, driver_no: String(form.driver_no) },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 수정 되었습니다.");
                        setEditMode?.(false);
                    },
                    onError: (error: any) => toast.error(error.message, toastErrorSyle),
                },
            );
            return;
        }

        createDriver(body, {
            onSuccess: (data: any) => {
                toast.success("성공적으로 등록 되었습니다.");
                const newNo = data?.data?.driver_no;
                navigate(newNo ? `/morning/customer/driver/${newNo}` : "/morning/customer/driver");
            },
            onError: (error: any) => toast.error(error.message, toastErrorSyle),
        });
    };

    return (
        <>
            {isPending || isPendingUpdate ? (
                <LoadingPop />
            ) : (
                <form onSubmit={onSubmit}>
                    <div className="mt-[8px] mb-[40px]">
                        <ConsoleHrozontalHeadTable
                            thead={[
                                {
                                    title: "기사명",
                                    key: "name",
                                    content: () => (
                                        <input
                                            type="text"
                                            value={form.name}
                                            onChange={e => setForm(prev => ({ ...prev, name: e.target.value }))}
                                            placeholder="기사명을 입력해주세요."
                                            className="border border-[#E1E2E4] rounded-[5px] px-3 h-[44px] text-[16px] w-full max-w-[400px]"
                                        />
                                    ),
                                },
                                {
                                    title: "전화번호",
                                    key: "phone",
                                    content: () => (
                                        <PatternFormat
                                            format="###-####-####"
                                            value={form.phone}
                                            onChange={e => setForm(prev => ({ ...prev, phone: e.target.value }))}
                                            placeholder="전화번호를 입력해주세요."
                                            className="border border-[#E1E2E4] rounded-[5px] px-3 h-[44px] text-[16px] w-full max-w-[400px]"
                                        />
                                    ),
                                },
                                {
                                    title: "차량번호",
                                    key: "car_no",
                                    content: () => (
                                        <input
                                            type="text"
                                            value={form.car_no}
                                            onChange={e => setForm(prev => ({ ...prev, car_no: e.target.value }))}
                                            placeholder="차량번호를 입력해주세요."
                                            className="border border-[#E1E2E4] rounded-[5px] px-3 h-[44px] text-[16px] w-full max-w-[400px]"
                                        />
                                    ),
                                },
                            ]}
                            tbody={form}
                        />

                        <div className="flex justify-center gap-2 mt-5">
                            <button className="bg-black text-white rounded-[5px] px-4 py-2">저장</button>
                            <button
                                type="button"
                                className="bg-black text-white rounded-[5px] px-4 py-2"
                                onClick={() => (update && setEditMode ? setEditMode(false) : navigate(-1))}
                            >
                                {update ? "취소" : "목록"}
                            </button>
                        </div>
                    </div>
                </form>
            )}
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
}
